module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ic-500d420982feb8a67cbcdd485d62f965.svg";